import { IPagination } from 'app/types/common';

export interface IPayment {
  id: string;
  type: string;
  description: string;
  amount: number;
  dueAt: Date;
  createdAt: Date;
  updatedAt: Date;
  status: string;
  collected: number;
  pending: number;
  pendingAmount: number;
  totalAmount: number;
  collectedAmount: number;
  total: number;
  numberOfTeams: number;
  numberOfTeamMembers: number;
  paymentType: string;
  paymentCategory: string;
  metadata: any;
  notificationLog: any;
  notificationConfiguration?: any;
  teams: {
    id: string;
    type: string;
    name: string;
    sport: string;
    userId: string;
    organisationId?: any;
    inviteToken: string;
    createdAt: Date;
    updatedAt: Date;
    status?: any;
    financialStatus: string;
    pendingTeamPaymentCollectionsTotalCount: number;
    paidTeamPaymentCollectionsTotalCount: number;
    overdueTeamPaymentCollectionsTotalCount: number;
    pendingTeamPaymentCollectionsTotalAmount: number;
    paidTeamPaymentCollectionsTotalAmount: number;
    overdueTeamPaymentCollectionsTotalAmount: number;
    numberOfTeamMembers: number;
  }[];
}

export interface IPaymentRequest {
  id: string;
  type: string;
  description: string;
  amount: number;
  dueAt: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  collected: number;
  pending: number;
  pendingAmount: number;
  totalAmount: number;
  collectedAmount: number;
  total: number;
  numberOfTeams: number;
  numberOfTeamMembers: number;
  paymentType: string;
  paymentCategory: string;
  metadata: {};
  notificationLog: {
    sendSmsInitialNotificationTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
    sendEmailInitialNotificationTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
    sendSmsDueReminderTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
    sendEmailDueReminderTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
  };
  notificationConfiguration?: {
    sendSmsInitialNotificationTeamMembers: boolean;
    sendEmailInitialNotificationTeamMembers: boolean;
    sendSmsDueReminderTeamMembers: boolean;
    sendEmailDueReminderTeamMembers: boolean;
  };
}

export interface IPaymentsState {
  readonly paymentsById?: any;
  readonly paymentIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddPayment?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentIds?: string[];
  readonly currentPaymentId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentsSelector extends IPaymentsState {
  readonly currentPayment?: any;
  readonly currentFormPayment?: any;
  readonly getPaymentsFilteredByTagInSelectFormat?: any;
  readonly paymentsByIdInSelectFormat?: any;
}

export enum PaymentsActionTypes {
  GET_ALL_PAYMENTS_REQUESTED = 'redux-app/payments/GET_ALL_PAYMENTS_REQUESTED',
  GET_ALL_PAYMENTS_PENDING = 'redux-app/payments/GET_ALL_PAYMENTS_PENDING',
  GET_ALL_PAYMENTS_SUCCESS = 'redux-app/payments/GET_ALL_PAYMENTS_SUCCESS',
  GET_ALL_PAYMENTS_FAIL = 'redux-app/payments/GET_ALL_PAYMENTS_FAIL',
  GET_PAYMENT_REQUESTED = 'redux-app/payments/GET_PAYMENT_REQUESTED',
  GET_PAYMENT_PENDING = 'redux-app/payments/GET_PAYMENT_PENDING',
  GET_PAYMENT_SUCCESS = 'redux-app/payments/GET_PAYMENT_SUCCESS',
  GET_PAYMENT_FAIL = 'redux-app/payments/GET_PAYMENT_FAIL',
  UPDATE_PAYMENT_REQUESTED = 'redux-app/payments/UPDATE_PAYMENT_REQUESTED',
  UPDATE_PAYMENT_PENDING = 'redux-app/payments/UPDATE_PAYMENT_PENDING',
  UPDATE_PAYMENT_SUCCESS = 'redux-app/payments/UPDATE_PAYMENT_SUCCESS',
  UPDATE_PAYMENT_FAIL = 'redux-app/payments/UPDATE_PAYMENT_FAIL',
  CREATE_PAYMENT_REQUESTED = 'redux-app/payments/CREATE_PAYMENT_REQUESTED',
  CREATE_PAYMENT_PENDING = 'redux-app/payments/CREATE_PAYMENT_PENDING',
  CREATE_PAYMENT_SUCCESS = 'redux-app/payments/CREATE_PAYMENT_SUCCESS',
  CREATE_PAYMENT_FAIL = 'redux-app/payments/CREATE_PAYMENT_FAIL',
  DELETE_PAYMENT_REQUESTED = 'redux-app/payments/DELETE_PAYMENT_REQUESTED',
  DELETE_PAYMENT_PENDING = 'redux-app/payments/DELETE_PAYMENT_PENDING',
  DELETE_PAYMENT_SUCCESS = 'redux-app/payments/DELETE_PAYMENT_SUCCESS',
  DELETE_PAYMENT_FAIL = 'redux-app/payments/DELETE_PAYMENT_FAIL',
  SELECT_PAYMENT_REQUESTED = 'redux-app/payments/SELECT_PAYMENT_REQUESTED',
}

export default null;
